import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout'
import Empty from 'general/components/Empty'
import AppResource from 'general/constants/AppResource'
import { useAppSelector } from 'hooks/useRedux'
import useRouter from 'hooks/useRouter'
import { useMemo, useRef, useState } from 'react'
import { Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Navigate, Route, Routes } from 'react-router-dom'
import styled from 'styled-components'
import Cart from './Cart'
import Category from './Category'
import Dashboard from './Dashboard'
import HandleInvoice from './HandleInvoice'
import HandleTicket from './HandleTicket'
import Invoice from './Invoice'
import SuccessFulOrder from './Payment/components/succesFulOrder/'
import Payment from './Payment/index.js'
import Process from './Process'
import Registration from './Registration'
import Report from './Report'
import System from './System'
import TaxMessage from './TaxMessage'
import TemplateInvoice from './TemplateInvoice'
import TemplateTicket from './TemplateTicket'
import Ticket from './Ticket'
import TaxDeduction from './TaxDeduction'
import TaxDeductionDocuments from './TaxDeductionDocuments'
import Taxpayer from './Taxpayer'
import EnterpriseProfile from './System/screens/EnterpriseProfile'
import Department from './Department'
import Jobposition from './Jobposition'
import ProtectedRoute from 'general/components/Routes/ProtectedRoute'
import UserManagement from './System/screens/UserManagement'
import UserNoFunction from 'general/components/UserNoFunction'
import RegistrationAccountingDocument from './RegistrationAccountingDocument'
import HandleDocument from './HandleDocument'
import ListTaxMessageRegistrationAccountingDocuments from './TaxMessage/screens/ListTaxMessageRegistrationAccountingDocuments'
import ListTaxMessageAccountingDocuments from './TaxMessage/screens/ListTaxMessageAccountingDocuments'
import ErrorAnnouncementAccountingDocument from './HandleInvoice/screens/ErrorAnnouncementAccountingDocument'
import SystemNotifycationModal from 'general/components/Modal/SystemNotifycationModal'
import InPutEInvoice from './InPutEInvoice'
import Notification from './System/Notification'
import CustomDrawer from './Invoice/components/Drawer'
import { FloatButton } from 'antd'
import { DoubleLeftOutlined, DownloadOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { setDrawerDowloadFie, clearDrawerDowloadFie } from 'app/appSlice'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import wsHelperInstance from 'general/helpers/WebSocketHelper'
import invoiceApi from 'api/invoiceApi'
import ToastHelper from 'general/helpers/ToastHelper'
const EinvoiceContainer = styled.section({
  minHeight: '100%',
  maxHeight: '100%',
  maxWidth: '100%',
  overflowY: 'auto',
})

function OutPutEInvoice() {
  // MARK: --- Props ---
  const { t } = useTranslation()
  const { pathname } = useRouter()
  const systemType = useAppSelector((s) => s.auth?.activeInvoice)
  const prefixPath = useMemo(
    () =>
      systemType?.invoice
        ? ''
        : systemType?.ticket
          ? 'tem-ve/'
          : systemType?.personalIncomeTax
            ? 'chung-tu-tncn/'
            : '',
    [systemType?.invoice, systemType?.ticket, systemType?.personalIncomeTax],
  )
  const user = useAppSelector((state) => state?.auth?.currentAccount)

  // show popup notice 2025
  const [isShowPopup, setShowPopup] = useState(true)
  const rootRef = useRef()
  const imgPath = AppResource.images.imgAnnouncements
  const [inforExportReportFileDetail, setInforExportReportFileDetail] =
    useState({ disable: false })
  const dispatch = useDispatch()
  const drawerDowloadFie = useAppSelector((state) => state.app.drawerDowloadFie)

  return (
    <KT01BaseLayout
      inforExportReportFileDetail={inforExportReportFileDetail}
      setInforExportReportFileDetail={(value) => {
        setInforExportReportFileDetail(value)
      }}
    >
      <EinvoiceContainer
        id="einvoice-container" /* container-fluid */
        className={`${
          pathname.includes('/hoa-don/them-moi') ||
          pathname.includes('/xu-ly-hoa-don/dieu-chinh') ||
          pathname.includes('/xu-ly-hoa-don/thay-the')
            ? 'px-0'
            : ''
        }`}
      >
        <Routes>
          <Route path={'/'} element={<Navigate to={'ban-lam-viec'} />} />
          <Route
            path={'ban-lam-viec/*'}
            element={
              <Dashboard personalIncomeTax={systemType?.personalIncomeTax} />
            }
          />
          <Route path={'tem-ve/ban-lam-viec/*'} element={<Dashboard />} />
          <Route
            path={prefixPath + 'lich-su-truyen-nhan/*'}
            element={<TaxMessage ticket={systemType?.ticket} />}
          />
          <Route path={prefixPath + 'to-khai/*'} element={<Registration />} />
          <Route
            path={prefixPath + 'hoa-don/*'}
            element={
              <Invoice
                drawerDowloadFie={drawerDowloadFie}
                setDrawerDowloadFie={async (data) => {
                  console.log('data', data)
                  await dispatch(setDrawerDowloadFie(data))
                  const invoiceIds = data?.data
                    .filter((item) => item.status === 'watting')
                    .map((item) => item.invoiceId)
                  let accessToken = localStorage.getItem(
                    PreferenceKeys.accessToken,
                  )
                  if (accessToken) {
                    wsHelperInstance.onExecutingDowloadFile(
                      accessToken,
                      invoiceIds,
                    )
                  }
                }}
              />
            }
          />
          <Route path={prefixPath + 've-dien-tu/*'} element={<Ticket />} />
          <Route
            path={prefixPath + 've-tu-may-tinh-tien/*'}
            element={<Ticket classify="MTT" />}
          />

          <Route
            path={prefixPath + 'bao-cao/*'}
            element={
              <Report
                inforExportReportFileDetail={inforExportReportFileDetail}
                setInforExportReportFileDetail={(value) => {
                  setInforExportReportFileDetail(value)
                }}
              />
            }
          />
          <Route
            path={prefixPath + 'mau-hoa-don/*'}
            element={<TemplateInvoice />}
          />
          <Route path={prefixPath + 'danh-muc/*'} element={<Category />} />
          <Route path={prefixPath + 'gio-hang/*'} element={<Cart />} />
          <Route path={prefixPath + 'thanh-toan/*'} element={<Payment />} />
          <Route
            path={prefixPath + 'dat-hang-thanh-cong/*'}
            element={<SuccessFulOrder />}
          />
          <Route
            path={prefixPath + 'xu-ly-hoa-don/*'}
            element={<HandleInvoice />}
          />

          <Route
            path={prefixPath + 'quy-trinh-nghiep-vu/*'}
            element={<Process />}
          />

          <Route
            path={prefixPath + 'mau-tem-ve/*'}
            element={<TemplateTicket />}
          />

          <Route path={prefixPath + 'xu-ly-ve/*'} element={<HandleTicket />} />

          <Route path={prefixPath + 'he-thong/*'} element={<System />} />

          <Route
            path={prefixPath + '/hoa-don-dau-vao/*'}
            element={<InPutEInvoice />}
          />

          <Route
            path="*"
            element={
              <Container fluid className="h-100 d-flex">
                <Row className=" justify-content-center align-items-center flex-grow-1">
                  <Empty
                    text={t('PageNotFound')}
                    buttonText={t('Refresh')}
                    visible={false}
                    imageEmptyPercentWidth={30}
                    imageEmpty={AppResource.icons.icEmptyBox}
                  />
                </Row>
              </Container>
            }
          />
          <Route
            path={prefixPath + 'khau-tru-thue-thu-nhap-ca-nhan/*'}
            element={<TaxDeduction />}
          />
          <Route
            path={prefixPath + 'xu-ly-ct/*'}
            element={<HandleDocument />}
          />
          <Route
            path={prefixPath + 'nguoi-nop-thue/*'}
            element={<Taxpayer />}
          />
          <Route
            path={prefixPath + 'thiet-lap/*'}
            element={<TaxDeductionDocuments />}
          />
          <Route
            path={prefixPath + 'mau-hoa-don/*'}
            element={<TemplateInvoice />}
          />
          <Route
            path={prefixPath + 'thong-tin-don-vi'}
            element={<EnterpriseProfile />}
          />
          <Route
            path={prefixPath + 'co-cau-to-chuc'}
            element={<Department />}
          />
          <Route
            path={prefixPath + 'vi-tri-cong-viec'}
            element={<Jobposition />}
          />
          <Route
            path={prefixPath + 'quan-ly-nguoi-dung'}
            element={
              <ProtectedRoute
                permission={user && user?.isAdmin}
                noPermission={UserNoFunction}
              >
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path={prefixPath + 'to-khai-tncn/*'}
            element={<RegistrationAccountingDocument />}
          />
          <Route
            path={prefixPath + 'lich-su-truyen-nhan/to-khai-tncn/*'}
            element={<ListTaxMessageRegistrationAccountingDocuments />}
          />
          <Route
            path={prefixPath + 'lich-su-truyen-nhan/chung-tu-dien-tu/*'}
            element={<ListTaxMessageAccountingDocuments />}
          />
          <Route
            path={
              prefixPath +
              'xu-ly-chung-tu/thong-bao-sai-sot/:accounting_documentsIds'
            }
            element={<ErrorAnnouncementAccountingDocument />}
          />
          <Route
            path={
              prefixPath +
              'xu-ly-chung-tu/chinh-sua-thong-bao-sai-sot/:errAnnouceId'
            }
            element={<ErrorAnnouncementAccountingDocument />}
          />
        </Routes>
        <SystemNotifycationModal />
        <Notification />
        <CustomDrawer
          drawerDowloadFie={drawerDowloadFie}
          setDrawerDowloadFie={(data) => {
            dispatch(setDrawerDowloadFie(data))
          }}
          clearDrawerDowloadFie={() => {
            dispatch(clearDrawerDowloadFie())
          }}
          title="Danh sách tải file"
          width={600}
          files={
            drawerDowloadFie?.data ?? []
            //   [
            //   {
            //     invoiceId: 1,
            //     pdf: { nameFile: 'hoa_don_1.pdf', pathDowload: '/hoa_don_1.pdf' },
            //     xml: { nameFile: 'hoa_don_1.xml', pathDowload: '/hoa_don_2.pdf' },
            //     no: '0001',
            //     serial: 'KH01',
            //     status: 'processing',
            //   },
            //   {
            //     invoiceId: 2,
            //     pdf: { nameFile: 'hoa_don_2.pdf', pathDowload: '/hoa_don_1.pdf' },
            //     xml: { nameFile: 'hoa_don_2.xml', pathDowload: '/hoa_don_2.pdf' },
            //     no: '0002',
            //     serial: 'KH02',
            //     status: 'error',
            //   },
            //   {
            //     invoiceId: 2,
            //     pdf: { nameFile: 'hoa_don_1.pdf', pathDowload: '/hoa_don_1.pdf' },
            //     xml: { nameFile: 'hoa_don_1.xml', pathDowload: '/hoa_don_2.pdf' },
            //     no: '0002',
            //     serial: 'KH02',
            //     status: 'success',
            //   },
            //   {
            //     invoiceId: 3,
            //     pdf: { nameFile: 'hoa_don_1.pdf', pathDowload: '/hoa_don_1.pdf' },
            //     xml: { nameFile: 'hoa_don_1.xml', pathDowload: '/hoa_don_2.pdf' },
            //     no: '0003',
            //     serial: 'watting',
            //   },
            // ]
          }
        ></CustomDrawer>
        {drawerDowloadFie?.data?.length > 0 && (
          <FloatButton
            type="primary"
            icon={<DoubleLeftOutlined />}
            tooltip="Hiển thị danh sách tải file"
            style={{
              width: 30,
              height: 30,
              right: 5,
              top: '50%',
              transform: 'translateY(-50%)',
            }}
            onClick={() => {
              dispatch(
                setDrawerDowloadFie({
                  ...drawerDowloadFie,
                  show: true,
                }),
              )
            }}
          />
        )}
      </EinvoiceContainer>
    </KT01BaseLayout>
  )
}

export default OutPutEInvoice
